import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Compressor from "compressorjs";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import { getBackendUrl } from "../../config";
import { Checkbox } from "@mui/material";
import { ModalTitle, usePanelStyles } from "../QueueIntegrationModal/panelKit";
import { useFlowModalStyles } from "../FlowBuilderModal/flowModalStyles";

const FlowBuilderAddAudioModal = ({ open, onSave, onUpdate, data, close }) => {
  const panel = usePanelStyles();
  const flow = useFlowModalStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const [record, setRecord] = useState(false);

  const [preview, setPreview] = useState();

  const [labels, setLabels] = useState({
    title: "Adicionar audio ao fluxo",
    btn: "Adicionar"
  });

  const [textDig, setTextDig] = useState();

  const [medias, setMedias] = useState([]);

  useEffect(() => {
    if (open === "edit") {
      setLabels({
        title: "Editar audio",
        btn: "Salvar"
      });
      setPreview(getBackendUrl() + '/public/' + data.data.url)
      setRecord(data.data.record)
      setActiveModal(true);
    } else if (open === "create") {
      setLabels({
        title: "Adicionar audio ao fluxo",
        btn: "Adicionar"
      });
      setTextDig("");
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = async () => {
    if (open === "edit") {
      handleClose();
      onUpdate({
        ...data,
        data: { url: data.data.url,
        record: record }
      });
      return;
    } else if (open === "create") {
      setLoading(true);
      const formData = new FormData();
      formData.append("fromMe", true);

      medias.forEach(async (media, idx) => {
        const file = media;

        if (!file) {
          return;
        }

        if (media?.type.split("/")[0] == "image") {
          new Compressor(file, {
            quality: 0.7,

            async success(media) {
              formData.append("medias", media);
              formData.append("body", media.name);
            },
            error(err) {
              alert("erro");
              console.log(err.message);
            }
          });
        } else {
          formData.append("medias", media);
          formData.append("body", media.name);
        }
      });

      setTimeout(async () => {
        // console.log(formData);
        await api.post("/flowbuilder/audio", formData).then(res => {
          handleClose();
          onSave({
            url: res.data.name,
            record: record
          });
          toast.success("Audio adicionada com sucesso!");
          setLoading(false);
          setMedias([]);
          setPreview();
        });
      }, 1000);
    }
  };

  const handleChangeMedias = e => {
    if (!e.target.files) {
      return;
    }

    if(e.target.files[0].size > 5000000){
      toast.error("Arquivo é muito grande! 5MB máximo")
      return
    }

    const selectedMedias = Array.from(e.target.files);
    setPreview((URL.createObjectURL(e.target.files[0])));
    setMedias(selectedMedias);
  };

  return (
    <Dialog
      open={activeModal}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      scroll="paper"
    >
      <ModalTitle
        id="form-dialog-title"
        title={labels.title}
        subtitle="Envia um áudio ao contato quando o fluxo chega neste ponto."
        onClose={handleClose}
      />
      <DialogContent>
        <div className={panel.stack}>
          <div className={flow.upload}>
            {preview && (
              <audio controls="controls" className={flow.audio}>
                <source src={preview} type="audio/mp3" />
                seu navegador não suporta HTML5
              </audio>
            )}
            {!loading && open !== "edit" && (
              <>
                <Button variant="outlined" component="label">
                  Enviar audio
                  <input
                    type="file"
                    accept="audio/ogg, audio/mp3"
                    disabled={loading}
                    hidden
                    onChange={handleChangeMedias}
                  />
                </Button>
                <span className={flow.uploadHint}>MP3 ou OGG, até 5 MB.</span>
              </>
            )}
            {loading && (
              <div className={flow.loading}>
                <CircularProgress />
              </div>
            )}
          </div>
          {preview && (
            <label className={flow.checkRow}>
              <Checkbox checked={record} onChange={(e) => setRecord(old => !old)}/>
              <span>Enviar como audio gravado na hora</span>
            </label>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        {!loading && (
          <>
            <Button
              onClick={() => {
                handleClose();
                setMedias([]);
                setPreview();
              }}
            >
              {i18n.t("contactModal.buttons.cancel")}
            </Button>
            <Button
              type="submit"
              disabled={loading}
              color="primary"
              variant="contained"
              onClick={() => handleSaveContact()}
            >
              {`${labels.btn}`}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderAddAudioModal;
